/**
 * adminUtils
 *
 * Helper for admin user management via Firebase custom claims.
 */

/**
 * Check if a user is an admin based on Firebase custom claims
 * 
 * @param {Object} user - The user object from auth context
 * @returns {boolean} - True if the user has isAdmin claim
 */
export const isUserAdmin = (user) => {
  return user?.isAdmin === true;
}; 